<template>
  <div>
    <div class="text-h2 mb-4 mt-6">
      {{ $t('profile.additionalInfo') }}
    </div>
    <v-row no-gutters justify="space-between" class="flex-column flex-md-row my-n2">
      <v-col class="pr-xxl-2 my-2 input_holder col-12 col-xxl-6">
        <DateSegmented
          :disabled="userDeactivated"
          :required="!!$auth.user.birthDate"
          :date-help-text="$t('profile.birthDateNote')"
          :initial-value="$auth.user.birthDate"
          @focus="handleFocusWithFormGtm($event?.target?.dataset?.part)"
        />
      </v-col>
      <v-col class="pl-xxl-2 my-2 input_holder col-12 col-xxl-6">
        <Sex :disabled="userDeactivated" :form-name="formName" />
      </v-col>
      <v-col class="pr-xxl-2 my-2 input_holder col-12 col-xxl-6">
        <AddressGoogle
          :form-name="formName"
          :messages="$t('profile.addressNote')"
          :title="$t('profile.address')"
          :disabled="userDeactivated"
        />
      </v-col>
      <v-col v-if="$auth.user.regionId !== 3" class="pl-xxl-2 my-2 input_holder col-12 col-xxl-6">
        <InsuranceCompany
          :holder-class="''"
          :form-name="formName"
          :messages="$t('profile.healthInsuranceProvider.note')"
          :title="$t('profile.healthInsuranceProvider.title')"
          :disabled="userDeactivated"
          :value="$auth.user.healthInsuranceCompany"
          :required="false"
        />
      </v-col>
      <template v-if="partnerMutations.length > 1 || ($auth.user && !$auth.user.benefit.active)">
        <v-col class="my-2 pr-xxl-2 input_holder col-12 col-xxl-6">
          <LanguageSelector
            id="serviceLanguage"
            v-model="language"
            :message="$t('profile.serviceLanguage.message')"
            :disabled="userDeactivated"
            :language-list="languageList"
            :label="$t('profile.serviceLanguage.title')"
          />
        </v-col>
      </template>
      <v-col
        v-if="showLanguageChangeNotification"
        md="12"
        class="my-8 d-flex flex-column flex-md-row align-start align-md-center"
      >
        <v-row align="center">
          <v-col cols="auto">
            <v-icon size="22" class="mr-2 notification-icon"> $info</v-icon>
          </v-col>
          <v-col cols="auto">
            {{ $t('profile.changeLanguageNotification.text') }}
            {{ $t('profile.changeLanguageNotification.' + language) }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import formGtm from '@/mixins/formGtm';
import accountSettings from '@/mixins/accountSettings';

export default {
  name: 'AdditionalData',
  mixins: [formGtm, accountSettings],
  computed: {
    ...mapGetters({
      userDeactivated: 'profile/dashboard/userDeactivated'
    })
  }
};
</script>
